import PropTypes from 'prop-types';
import Can from '../common/guards/can';

const EditButton = ({show, onClick}) => show && (
  <div>
    <Can action="edit" subjectClass="Page">
      <a className="btn btn-grey edit-page-button" onClick={onClick}>
        <i className="fa fa-edit" aria-hidden="true"/>
        Edit page
      </a>
    </Can>
  </div>
);

EditButton.propTypes = {
  show: PropTypes.bool,
};

export default EditButton;
